export default __webpack_public_path__ + "static/media/background.50f6fc45.svg";